// extracted by mini-css-extract-plugin
export default {"layout":"src_layout__ORBk9"};